import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

// Shape of the parent-supplied sink; registered while the form is dirty, null withdraws it.
export type StageSubmitRegistrar = (id: string, submit: (() => Promise<unknown>) | null) => void;

interface IFormikSubmitRegistrarProps {
  id: string;
  register?: StageSubmitRegistrar;
}

// Lets a parent-level Save flush this form's pending edits first — the form's own submit
// button may be scrolled out of view. Renders nothing; must sit inside the Formik provider.
export const FormikSubmitRegistrar: React.FC<IFormikSubmitRegistrarProps> = ({ id, register }) => {
  const { dirty, submitForm } = useFormikContext();

  useEffect(() => {
    if (!register) return undefined;
    register(id, dirty ? submitForm : null);
    return () => register(id, null);
  }, [register, id, dirty, submitForm]);

  return null;
};
